import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    let cancelled = false;
    const poll = async (n) => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch {}
      if (n >= 8) { setState("timeout"); return; }
      setTries(n + 1);
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  }, [refresh]);

  return (
    <div className="min-h-[70vh] grid place-items-center" data-testid="payment-success-page">
      <div className="card-soft p-12 text-center max-w-md">
        {state === "checking" && <><Loader2 className="w-12 h-12 text-emerald-500 animate-spin mx-auto mb-4" /><h2 className="font-display text-2xl font-bold text-[color:var(--navy)]">Confirming payment...</h2><p className="text-[color:var(--ink-3)] mt-2">Attempt {tries + 1}/9</p></>}
        {state === "paid" && <><CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" /><h2 className="font-display text-2xl font-bold text-[color:var(--navy)]">Payment successful!</h2><p className="text-[color:var(--ink-2)] mt-2">Your lead credits have been added to your account.</p><Button onClick={() => nav("/dashboard")} className="btn-primary rounded-full mt-6 px-8" data-testid="payment-goto-dashboard">Go to Dashboard</Button></>}
        {(state === "error" || state === "timeout") && <><XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" /><h2 className="font-display text-2xl font-bold text-[color:var(--navy)]">{state === "timeout" ? "Still processing" : "Payment issue"}</h2><p className="text-[color:var(--ink-2)] mt-2">{state === "timeout" ? "It's taking longer than expected. Check your dashboard shortly." : "We couldn't confirm your payment."}</p><Button onClick={() => nav("/dashboard")} className="btn-primary rounded-full mt-6 px-8">Go to Dashboard</Button></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-[70vh] grid place-items-center" data-testid="payment-cancel-page">
      <div className="card-soft p-12 text-center max-w-md">
        <XCircle className="w-14 h-14 text-[color:var(--ink-3)] mx-auto mb-4" />
        <h2 className="font-display text-2xl font-bold text-[color:var(--navy)]">Checkout cancelled</h2>
        <p className="text-[color:var(--ink-2)] mt-2">No charge was made. You can pick a plan any time.</p>
        <Button onClick={() => nav("/pricing")} className="btn-primary rounded-full mt-6 px-8">Back to Pricing</Button>
      </div>
    </div>
  );
}
